import { render, staticRenderFns } from "./OrderChangeLog.vue?vue&type=template&id=6fb10122&scoped=true"
import script from "./OrderChangeLog.vue?vue&type=script&lang=js"
export * from "./OrderChangeLog.vue?vue&type=script&lang=js"
import style0 from "./OrderChangeLog.vue?vue&type=style&index=0&id=6fb10122&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb10122",
  null
  
)

export default component.exports